<template>
  <div class="gs-accordion">
    <div
      v-for="section in sections"
      :key="section.value"
      class="gs-accordion__section"
      :class="{ 'is-open': section.value === value }"
    >
      <button
        type="button"
        class="gs-accordion__trigger"
        :data-section="section.value"
        :aria-expanded="section.value === value ? 'true' : 'false'"
        @click="toggle(section.value)"
      >
        <span class="gs-accordion__heading">
          <span class="gs-accordion__title">{{ section.title }}</span>
          <span v-if="section.hint" class="gs-accordion__hint">{{ section.hint }}</span>
        </span>
        <gs-icon
          class="gs-accordion__chevron"
          :name="section.value === value ? 'chevron-up' : 'chevron-down'"
          size="16"
        />
      </button>
      <div v-if="section.value === value" class="gs-accordion__panel">
        <slot :name="section.value"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GsAccordion',

  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },

  methods: {
    toggle(section) {
      this.$emit('input', section === this.value ? '' : section);
    },
  },
};
</script>

<style scoped>
.gs-accordion {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gs-accordion__section {
  overflow: hidden;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
}

.gs-accordion__section.is-open {
  border-color: var(--gs-border-strong);
  box-shadow: var(--gs-shadow-sm);
}

.gs-accordion__trigger {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  color: var(--gs-foreground);
  text-align: left;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.gs-accordion__trigger:hover {
  background: var(--gs-surface-subtle);
}

.gs-accordion__trigger:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gs-accordion__heading {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.gs-accordion__title {
  font-size: 15px;
  font-weight: 700;
}

.gs-accordion__hint {
  color: var(--gs-muted-foreground);
  font-size: 12px;
}

.gs-accordion__chevron {
  flex: 0 0 auto;
  color: var(--gs-muted-foreground);
}

.gs-accordion__panel {
  padding: 4px 16px 18px;
  border-top: 1px solid var(--gs-border);
}
</style>
